import { useEffect } from "react";
import { registerWebMcpTools } from "./registerWebMcpTools";

// Registers NetRiskScan's WebMCP tools against `document.modelContext` so a WebMCP-capable agent
// visiting the site can discover them. Mounted once near the app root (see App.tsx) rather than inside
// HomePage, because these are whole-site capabilities, not state tied to one page's lookup form.
// Renders nothing.
//
// The AbortController is what makes this StrictMode-safe: React's dev-mode double-invoke (mount ->
// cleanup -> mount) would otherwise register the same two tools twice, since nothing else would ever
// retract the first mount's registration — aborting the signal on cleanup is the one retraction
// mechanism the WebMCP spec gives a page (`ModelContextRegisterToolOptions.signal`).
export function WebMcpBridge() {
  useEffect(() => {
    const controller = new AbortController();
    const context = typeof document === "undefined" ? undefined : document.modelContext;
    registerWebMcpTools(context, { signal: controller.signal });
    return () => controller.abort();
  }, []);

  return null;
}
